import {execToast} from 'src/_metronic/_partials/controls/Toast';

export function isErrorPermission(StatusCode: number) {
  if (StatusCode == 403) {
    execToast('error', 'Usuário não possui autorização!', 3000);
  }
}
